<template>
  <div style="min-width: 960px">
    <div class="mainWrap">
      <div class="header">
        <div class="leftWrap">
          <img src="../../assets/img/map/logo_white.png" alt="" class="logo" />
          <span class="orderNum">{{ trackInfo.order_no }}</span>
          <span class="orderStatus">{{ trackInfo.state }}</span>
        </div>
        <div class="rightWrap">
          <div class="statusItem" :class="{ active: dataindex >= 0 }">
            <div class="circle"></div>
            <span class="title">已订舱 </span>
            <span class="info">{{ trackInfo.state_dc_time }}</span>
          </div>
          <div class="statusItem" :class="{ active: dataindex >= 1 }">
            <div class="circle"></div>
            <span class="title">已发出 </span>
            <span class="info">{{ trackInfo.state_fc_time }}</span>
          </div>
          <div class="statusItem" :class="{ active: dataindex >= 2 }">
            <div class="circle"></div>
            <span class="title">已收货 </span>
            <span class="info">{{ trackInfo.state_sh_time }}</span>
          </div>
          <div class="statusItem" :class="{ active: dataindex >= 3 }">
            <div class="circle"></div>
            <span class="title">已安检 </span>
            <span class="info">{{ trackInfo.state_aj_time }}</span>
          </div>
          <div class="statusItem" :class="{ active: dataindex >= 4 }">
            <div class="circle"></div>
            <span class="title">已入库 </span>
            <span class="info">{{ trackInfo.state_rk_time }}</span>
          </div>
          <div class="statusItem" :class="{ active: dataindex >= 5 }">
            <div class="circle"></div>
            <span class="title">已组板 </span>
            <span class="info">{{ trackInfo.state_zb_time }}</span>
          </div>
          <div class="statusItem" :class="{ active: dataindex >= 6 }">
            <div class="circle"></div>
            <span class="title">已起飞 </span>
            <span class="info">{{ trackInfo.state_qf_time }}</span>
          </div>
          <div class="statusItem" :class="{ active: dataindex >= 7 }">
            <div class="circle"></div>
            <span class="title">已落地 </span>
            <span class="info">{{ trackInfo.state_ld_time }}</span>
          </div>
          <div class="statusItem" :class="{ active: dataindex >= 8 }">
            <div class="circle"></div>
            <span class="title">已提货 </span>
            <span class="info">{{ trackInfo.state_th_time }}</span>
          </div>
        </div>
      </div>
      <div class="mainContent">
        <Draw_Map
          id="map"
          :collRes="trackInfo.coll_res"
          :giveRes="trackInfo.give_res"
          :trackInfo="trackInfo"
          v-if="trackInfo"
        />
        <div
          :class="`airDetail ${!trackInfo.transfer_port_three_no && 'small'}`"
          v-show="xuanze == false"
        >
          <div :class="`trackHeader ${noHeader && 'noHeader'}`">
            <div class="trackItem">
              <!-- 如果有起飞时间或者是提单状态为已起飞和已落地  那个箭头变绿 class类-->
              <!-- 横线上的内容为data-no -->
              <span
                class="title"
                :class="{
                  titlest: dataindex >= 6 || trackInfo.actual_depart_time,
                }"
                :data-no="trackInfo.voyage_name"
                >{{ trackInfo.depart_port_three_no }}</span
              >
              <div class="timeDetail">
                <!-- 如果有起飞时间或者是有预计起飞时间显示 -->
                <span>{{
                  trackInfo.actual_depart_time || plan_departTime
                }}</span>
                <!-- 这里是卡车信息 -->
                <span
                  :class="`no ${
                    trackInfo.coll_res &&
                    trackInfo.coll_res.c_truck_name &&
                    'top'
                  }`"
                  >{{
                    trackInfo.coll_res && trackInfo.coll_res.c_truck_name
                  }}</span
                >
              </div>
            </div>
            <!-- 中转站暂时不要了，屏蔽掉 -->
            <!-- <div class="trackItem" v-if="trackInfo.transfer_port_three_no">
              如果有实际落地时间或者是提单状态为已落地  箭头变绿
              <span class="title" :class="{ titlest:dataindex>=7}"
                :data-no="trackInfo.transfer_voyage_name">{{trackInfo.transfer_port_three_no}}</span>
            </div> -->
            <!-- <div class="transform_time">中转2次</div> -->
            <div class="trackItem">
              <span
                class="title fortext"
                :class="{ titlest: trackInfo.actual_arrive_time }"
                :data-name="
                  trackInfo.stop_over_num > 0
                    ? '中转' + trackInfo.stop_over_num + '次'
                    : ''
                "
                >{{ trackInfo.arrive_port_three_no }}</span
              >
              <div class="timeDetail">
                <!-- 落地时间和预计落地时间 -->
                <span>{{trackInfo.actual_arrive_time? trackInfo.actual_arrive_time:trackInfo.state_ld_time? trackInfo.state_ld_time:plan_arriveTime }}</span>
                <!-- 卡车相关信息 -->
                <span
                  :class="`no ${
                    trackInfo.give_res &&
                    trackInfo.give_res.g_truck_name &&
                    'bottom'
                  }`"
                  >{{
                    trackInfo.give_res && trackInfo.give_res.g_truck_name
                  }}</span
                >
              </div>
            </div>
          </div>

          <div class="progressWrap">
            <p class="title">
              <span>{{ trackInfo.order_no }}&nbsp;</span>[{{
                trackInfo.order_volume
              }}M³<sup></sup> {{ trackInfo.order_weight }}KG
              {{ trackInfo.order_number }}箱]
            </p>
            <div class="progress">
              <span>进度：</span>
              <div>
                <div
                  class="fill"
                  :data-rate="`${trackInfo.progress_bar || 0}%`"
                  :style="`width:${trackInfo.progress_bar || 0}%;`"
                ></div>
              </div>
            </div>
          </div>

          <div class="routeWrap">
            <div class="routeItem" v-if="hasStartList">
              <div class="routeItemHeader">
                <div class="iconWrap">
                  <div><img src="../../assets/img/map/car.png" alt="" /></div>
                </div>
                <label>接货揽收：</label>
                <span>{{ trackInfo.coll_res.coll_address }}</span>
              </div>
              <div
                :class="{
                  routeDetails:
                    dataindex <= 0 && trackInfo.coll_res.coll_time == '',
                  routeDetail:
                    dataindex >= 1 || trackInfo.coll_res.coll_time !== '',
                }"
              >
                <div class="leftWrap">
                  <span class="routeNo">{{
                    trackInfo.coll_res.c_truck_name
                  }}</span>
                  <span
                    class="routeTime"
                    v-if="trackInfo.state_fc_time == '' && trackInfo.coll_res.coll_time=='' && dataindex<1"
                    >{{ trackInfo.coll_res.expect_coll_time }}</span
                  >
                </div>
                <div class="rightWrap">
                  <div class="timeLine">
                    <div class="tlItem active">
                      <span
                        v-if="
                          dataindex <= 0 && trackInfo.coll_res.coll_time == ''
                        "
                      >
                        待揽收
                      </span>
                      <span
                        v-if="
                          dataindex >= 1 || trackInfo.coll_res.coll_time !== ''
                        "
                      >
                        已揽收
                      </span>
                    </div>
                    <div
                      class="tlItem"
                      :class="{
                        active: dataindex >= 1 || trackInfo.coll_res.coll_time,
                      }"
                    >
                      <span>揽收时间：{{ trackInfo.coll_res.coll_time }}</span>
                    </div>
                    <!-- 如果有发出时间,线条圆点变色 只显示多辆揽收车辆的第一条信息 -->
                    <div
                      class="tlItem"
                      :class="{
                        active: dataindex >= 1 || trackInfo.coll_res.coll_time,
                      }"
                    >
                      <div
                        v-for="(item, index) in trackInfo.coll_res.coll_data"
                        :key="index"
                      >
                        <span>运输卡车：{{ item.coll_truck_name }}</span>
                        <span class="text-number"
                          >[{{ item.volume }}M³<sup></sup> {{ item.weight }}KG
                          {{ item.number }}箱]</span
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="routeItem" v-if="trackInfo.depart_port_name_cn">
              <div class="routeItemHeader">
                <div class="iconWrap">
                  <!-- 如果 接收 安检 入库 组板 离开 时间都为空，显示灰色图标 -->
                  <div v-if="takeoff_icon == 1">
                    <img src="../../assets/img/map/huifj.png" alt="" />
                  </div>
                  <!-- 如果 接收 安检 入库 组板 离开 时间任意不为空，显示绿色图标 -->
                  <div v-if="takeoff_icon == 0">
                    <img src="../../assets/img/map/icon.png" alt="" />
                  </div>
                </div>
                <label>起运机场：</label>
                <span>{{ trackInfo.depart_port_name_cn }}</span>
              </div>
              <!-- 如果起飞时间为空 且状态低于已起飞 -->
              <div
                v-bind:class="[tackoff_wire ? 'routeDetails' : 'routeDetail']"
              >
                <div class="leftWrap">
                  <span class="routeNo">{{ trackInfo.voyage_name }}</span>
                  <span class="routeTime zhanwei">{{
                    trackInfo.actual_depart_time == "" ? plan_departTime : ""
                  }}</span>

                  <!-- <el-tooltip
                    class="item"
                    effect="dark"
                    content="Top Left 提示文字"
                    placement="top"
                  > -->
                  <div class="fenpi" v-if="trackInfo.is_batches">分批拉货</div>
                  <!-- </el-tooltip> -->
                </div>
                <div class="rightWrap">
                  <div class="timeLine">
                    <div class="tlItem" :class="{ active: dataindex >= 2 }">
                      <span>接收时间：{{ trackInfo.state_sh_time }}</span>
                    </div>
                    <div class="tlItem" :class="{ active: dataindex >= 3 }">
                      <span>安检时间：{{ trackInfo.state_aj_time }}</span>
                    </div>
                    <div class="tlItem" :class="{ active: dataindex >= 4 }">
                      <span>入库时间：{{ trackInfo.state_rk_time }}</span>
                    </div>
                    <div class="tlItem" :class="{ active: dataindex >= 5 }">
                      <span
                        >组板时间：{{
                          trackInfo.now_board_time || trackInfo.state_zb_time
                        }}</span
                      >
                    </div>
                    <div class="tlItem" :class="{ active: dataindex >= 6 }">
                      <span>离开时间：{{ trackInfo.actual_depart_time }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- 中转机场修改这里增加v-for -->

            <div
              class="routeItem"
              v-for="(i, index) in transform_list"
              :key="index"
            >
              <div class="routeItemHeader">
                <div class="iconWrap">
                  <div v-if="!trackInfo.actual_depart_time">
                    <img src="../../assets/img/zhongzhuan2.png" alt="" />
                  </div>
                  <div v-else>
                    <img src="../../assets/img/zhongzhuan.png" alt="" />
                  </div>
                </div>
                <label>经停机场：</label>
                <span>{{ i.arrive_port_name_cn }}</span>
              </div>
              <div
                v-bind:class="{
                  routeDetail: dataindex >= 6,
                  routeDetails: dataindex < 6,
                }"
              >
                <div class="leftWrap">
                  <span class="routeNo">{{
                    trackInfo.transfer_voyage_name || trackInfo.voyage_name
                  }}</span>
                  <span
                    class="routeTime"
                    style="padding-bottom:10px"
                    v-if="
                      i.actual_depart_time == '' &&
                      trackInfo.actual_arrive_time == ''
                    "
                    >{{ i.plan_depart_time }}</span
                  >
                </div>
              </div>
            </div>
            <div class="routeItem" v-if="trackInfo.arrive_port_name_cn">
              <div class="routeItemHeader">
                <div class="iconWrap">
                  <div v-if="dataindex < 7">
                    <img src="../../assets/img/jiangluo2.png" alt="" />
                  </div>
                  <div v-if="dataindex >= 7">
                    <img src="../../assets/img/jiangluo.png" alt="" />
                  </div>
                </div>
                <label>到达机场：</label>
                <span>{{ trackInfo.arrive_port_name_cn }}</span>
              </div>
              <div
                :class="
                  dataindex>=7 ? 'routeDetail' : 'routeDetails'
                "
              >
                <div class="leftWrap">
                  <span class="routeNo">{{
                    trackInfo.transfer_voyage_name || trackInfo.voyage_name
                  }}</span>
                  <span class="routeTime" v-if="dataindex < 7">{{
                    plan_arriveTime
                  }}</span>
                </div>

                <div class="rightWrap">
                  <div class="timeLine">
                    <div :class="`tlItem ${dataindex >= 7 && 'active'}`">
                      <span>到达时间：{{trackInfo.actual_arrive_time}}</span>
                    </div>
                    <div :class="`tlItem ${dataindex >= 8 && 'active'}`">
                      <span>提货时间：{{ trackInfo.state_th_time }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="routeItem" v-if="hasEndList">
              <div class="routeItemHeader">
                <div class="iconWrap">
                  <div v-if="dataindex < 7">
                    <img src="../../assets/img/huicar1.png" alt="" />
                  </div>
                  <div v-if="dataindex >= 7">
                    <img src="../../assets/img/car1.png" alt="" />
                  </div>
                </div>
                <div  class="my">
                  <div class='my_left'>
                    <label>送货终点：</label>
                    <div class="routeNo">{{
                      trackInfo.give_res.g_truck_name
                    }}</div>
                  </div>

                  <span class="address_text">{{
                    trackInfo.give_res.give_address
                  }}</span>
                </div>
              </div>
              <div
                v-bind:class="{
                  routeDetail: trackInfo.give_res.give_time !== '',
                  routeDetails: trackInfo.give_res.give_time == '',
                }"
              >
                <div class="leftWrap">
                  <span
                    class="routeTime"
                    v-if="trackInfo.give_res.coll_time == ''"
                    >{{ trackInfo.give_res.expect_coll_time }}</span
                  >
                </div>
                <div class="rightWrap">
                  <div class="timeLine">
                    <div class="tlItem active">
                      <span>{{
                        trackInfo.give_res.coll_time ? "已揽收" : "待揽收"
                      }}</span>
                    </div>
                   

                    <div
                      :class="`tlItem ${
                        trackInfo.give_res.coll_time && 'active'
                      }`"
                    >
                      <div>
                        <span
                          >揽收时间：{{ trackInfo.give_res.coll_time }}</span
                        >
                      </div>
                    </div>

                     <div :class="['tlItem', trackInfo.give_res.coll_time!=''? 'active':'']">
                      <div
                        v-for="(item, index) in trackInfo.give_res.give_data"
                        :key="index"
                      >
                        <span>运输卡车：{{ item.give_truck_name }}</span>
                        <span class="text-number"
                          >[{{ item.volume }}M³<sup></sup> {{ item.weight }}KG
                          {{ item.number }}箱]</span
                        >
                      </div>
                    </div>

                    <div
                      :class="`tlItem ${
                        trackInfo.give_res.give_time && 'active'
                      }`"
                    >
                      <span>送达时间：{{ trackInfo.give_res.give_time }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<!-- 更换请求方式   更换请求数据字段 -->
<script>
import * as turf from "@turf/turf";
import Draw_Map from "../draw_map/draw_map.vue";
import { STATUS_LIST } from "../../assets/js/constant.js";
export default {
  components: {
    Draw_Map,
  },
  data() {
    return {
      xuanze: "",
      statusList: STATUS_LIST,
      orderNo: "",
      trackInfo: {},
      isEmpty: false,
      sty: "1",
      rarry: "",
      trackInfo: {},
      dataindex: "",
      transform_list: [],
      plan_arriveTime: "", //预计到达时间
      plan_departTime: "", //预计离开时间1
    };
  },
  beforeCreate() {},
  created() {
    this.query();
    if (this.xuanze == true) {
    }
    if (!this.orderNo) {
      this.isEmpty = true;
      return;
    }
  },
  computed: {
    StatusTime() {
      return (status) => {
        switch (status) {
          case "已订舱":
            return this.trackInfo.state_dc_time;
          case "已发出":
            return this.trackInfo.state_fc_time;
          case "已收货":
            return this.trackInfo.state_sh_time;
          case "已安检":
            return this.trackInfo.state_aj_time;
          case "已入库":
            return this.trackInfo.state_rk_time;
          case "已组板":
            return this.trackInfo.state_zb_time;
          case "已起飞":
            return this.trackInfo.state_qf_time;
          case "已落地":
            return this.trackInfo.state_ld_time;
          case "已完成":
            return this.trackInfo.state_wc_time;
          case "已提货":
            return this.trackInfo.state_th_time;
          default:
            return "";
        }
      };
    },

    hasEndList() {
      return this.trackInfo.give_res.give_address;
    },
    hasStartList() {
      return this.trackInfo.coll_res.coll_address;
    },
    // 起飞机场图标判断
    takeoff_icon() {
      var flag =
        this.trackInfo.state_sh_time == "" &&
        this.trackInfo.state_aj_time == "" &&
        this.trackInfo.state_rk_time == "" &&
        this.trackInfo.state_zb_time == "" &&
        this.trackInfo.state_qf_time == "";
      var takeoff_index = 0;
      if (flag) {
        takeoff_index = 1;
      }
      return takeoff_index;
    },
    // 起飞机场图标判断
    tackoff_wire() {
      return (
        this.trackInfo.state_qf_time == "" &&
        this.trackInfo.state !== "已起飞" &&
        this.trackInfo.state !== "已落地" &&
        this.trackInfo.state !== "已提货"
      );
    },
    noHeader() {
      if (
        /Android|webOS|iPhone|iPod|BlackBerry|iPad/i.test(navigator.userAgent)
      ) {
        this.xuanze = true;
        document.title = this.orderNo;
      } else {
        this.xuanze = false;
      }

      return (
        !(this.trackInfo.coll_res && this.trackInfo.coll_res.c_truck_name) &&
        !(this.trackInfo.give_res && this.trackInfo.give_res.g_truck_name)
      );
    },
  },
  methods: {
    query() {
      var order_no = this.$route.query.order_no;
      let data = { order_no: order_no };
      //  data = JSON.stringify(data)
      this.$source.post("/v1/flight_order/detail/track", data).then(
        (res) => {
          console.log(res);

          this.trackInfo = res.data.data || {};
          if (this.trackInfo.route_list.length > 0) {
            this.plan_departTime =
              this.trackInfo.route_list[0].plan_depart_time;
            this.plan_arriveTime =
              this.trackInfo.route_list[
                this.trackInfo.route_list.length - 1
              ].plan_arrive_time;
          }

          //處理数据获取中转站信息
          for (let i = 0; i < this.trackInfo.route_list.length; i++) {
            if (i + 1 < this.trackInfo.route_list.length) {
              if (
                this.trackInfo.route_list[i].arrive_port_three_no ==
                this.trackInfo.route_list[i + 1].depart_port_three_no
              ) {
                var data = {
                  arrive_port_latitude:
                    this.trackInfo.route_list[i].arrive_port_latitude,
                  arrive_port_longitude:
                    this.trackInfo.route_list[i].arrive_port_longitude,
                  arrive_port_name_cn:
                    this.trackInfo.route_list[i].arrive_port_name_cn,
                  arrive_port_three_no:
                    this.trackInfo.route_list[i].arrive_port_three_no,
                  arrive_port_time_zone:
                    this.trackInfo.route_list[i].arrive_port_time_zone,
                  actual_arrive_time:
                    this.trackInfo.route_list[i].actual_arrive_time,
                  actual_depart_time:
                    this.trackInfo.route_list[i+1].actual_depart_time,
                  plan_arrive_time:
                    this.trackInfo.route_list[i].plan_arrive_time,
                  plan_depart_time:
                    this.trackInfo.route_list[i + 1].plan_depart_time,
                };
                this.transform_list.push(data);
                console.log(this.transform_list,99886)
              }
            }
          }

          this.dataindexs();
        },
        (err) => {}
      );
    },

    dataindexs() {
      if (
        this.trackInfo.state == "已订舱" ||
        this.trackInfo.state_dc_time !== ""
      ) {
        //已订舱时间
        this.dataindex = 0;
      }
      if (
        this.trackInfo.state == "已发出" ||
        this.trackInfo.state_fc_time !== ""
      ) {
        //已发出时间
        this.dataindex = 1;
      }
      if (
        this.trackInfo.state == "已收货" ||
        this.trackInfo.state_sh_time !== ""
      ) {
        //已收货时间
        this.dataindex = 2;
      }
      if (
        this.trackInfo.state == "已安检" ||
        this.trackInfo.state_aj_time !== ""
      ) {
        //已安检时间
        this.dataindex = 3;
      }
      if (
        this.trackInfo.state == "已入库" ||
        this.trackInfo.state_rk_time !== ""
      ) {
        //已入库时间
        this.dataindex = 4;
      }
      if (
        this.trackInfo.state == "已组板" ||
        this.trackInfo.state_zb_time !== ""
      ) {
        //已组板时间
        this.dataindex = 5;
      }
      if (
        this.trackInfo.state == "已起飞" ||
        this.trackInfo.state_qf_time !== ""
      ) {
        //已发货时间
        this.dataindex = 6;
      }
      if (
        this.trackInfo.state == "已落地" ||
        this.trackInfo.state_ld_time !== ""
      ) {
        //已落地时间
        this.dataindex = 7;
      }
      if (
        this.trackInfo.state == "已提货" ||
        this.trackInfo.state_wc_time !== ""
      ) {
        //待结算时间
        this.dataindex = 8;
      }
      if (
        this.trackInfo.state == "已完成" ||
        this.trackInfo.state_th_time !== ""
      ) {
        //已完成时间
        this.dataindex = 9;
      }
    },

    getPath() {
      console.log(1111);
    },
  },
  // 监听路由变化
  watch: {
    $route: "getPath",
  },
};
</script>
<style lang="less">

.my_left{

}
.my{
  display: flex;
}
.text-number {
  padding-left: 65px;
}
@import url("../../assets/css/map.less");
.address_text {
  display: inline-block;
  width: 300px;
  text-align: left;
  word-break: break-all;
  padding-top: 3px;
  padding-left: 5px;
}
 .fenpi {
  width: 0.416667rem;
  height: 0.125rem;
  text-align: center;
  background-color: #359854;
  border-radius: 0.026042rem;
  line-height: 0.125rem;
  margin-bottom: 0.026042rem;
  font-size: 0.072917rem;
  color: #fff;
  font-size: 12px;
}
.zhanwei {
  width:80px;
  height: 40px;
}
.trackHeader .title {
  height: 20px;
  width: 150px;
  display: inline-block;
}
.mapboxgl-popup /deep/ .mapboxgl-popup-content {
  position: relative;
  background: transparent !important;
  border-radius: 3px;
  box-shadow: none !important;
  padding: 10px 10px 15px;
  pointer-events: auto;
  border: 0;
  padding: 6px;
}
.transform_time {
  width: 60px;
  height: 15px;
  border-radius: 10px;
  color: rgb(133, 164, 182);
  position: absolute;
  right: 50%;
  margin-right: -20px;
  margin-top: 5px;
}
.fortext::before {
  content: attr(data-name);
  display: block;
  position: absolute;
  font-size: 12px;
  left: -100px;
  top: 15px;
  color: #a2a2a2;
  width: 80px;
  text-align: center;

}
.my .routeNo {
  width: 80px;
  height: 24px;
  text-align: center;
  background-color: #e4e7ed;
  border-radius: 5px;
  line-height: 24px;
  margin-bottom: 5px;
  font-size: 14px;
  margin-top: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/public/map.vue